import React, { useEffect, useState } from 'react';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --blue: #00BCD4;
    --blue-mid: #00BCD4;
    --blue-light: #80DEEA;
    --blue-pale: #E0F7FA;
    --blue-dark: #008C9E;
    --white: #ffffff;
    --off-white: #E0F7FA;
    --text-dark: #000000;
    --text-mid: #424242;
    --text-light: #757575;
    --radius: 20px;
    --radius-sm: 12px;
  }

  html { scroll-behavior: smooth; }

  body {
    font-family: 'Roboto', sans-serif;
    background: var(--white);
    color: var(--text-dark);
    overflow-x: hidden;
  }

  /* ── NAV ── */
  .nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    padding: 18px 0;
    backdrop-filter: blur(18px);
    background: rgba(255,255,255,0.88);
    border-bottom: 1px solid rgba(26,111,212,0.08);
    transition: all 0.3s ease;
  }
  .nav.scrolled {
    padding: 12px 0;
    background: rgba(255,255,255,0.97);
    box-shadow: 0 4px 30px rgba(26,111,212,0.1);
  }
  .nav-inner {
    max-width: 1200px; margin: 0 auto;
    padding: 0 32px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .nav-brand {
    display: flex; align-items: center; gap: 10px;
    text-decoration: none;
    margin-right: 24px;
  }
  .nav-logo-box {
    width: 40px; height: 40px; border-radius: 10px;
    background: var(--blue);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Roboto', sans-serif;
    font-weight: 800; font-size: 20px; color: white;
    letter-spacing: -1px;
  }
  .nav-brand-name {
    font-family: 'Roboto', sans-serif;
    font-weight: 700; font-size: 17px; color: var(--text-dark);
  }
  .nav-links {
    display: flex; align-items: center; gap: 32px;
    list-style: none;
  }
  .nav-links a {
    text-decoration: none; font-size: 14px; font-weight: 500;
    color: var(--text-mid); transition: color 0.2s;
  }
  .nav-links a:hover { color: var(--blue); }
  .nav-links a.active { color: var(--blue); }
  .btn-nav {
    background: var(--blue); color: white !important;
    padding: 10px 22px; border-radius: 50px;
    font-weight: 600 !important; font-size: 13px !important;
    transition: background 0.2s, transform 0.15s !important;
  }
  .btn-nav:hover { background: var(--blue-dark) !important; transform: translateY(-1px); }

  /* ── HERO ── */
  .hero {
    min-height: 100vh;
    padding: 120px 0 80px;
    position: relative;
    overflow: hidden;
    background: var(--off-white);
  }
  .hero-bg {
    position: absolute; inset: 0; pointer-events: none;
    background:
      radial-gradient(ellipse 60% 60% at 80% 20%, rgba(26,111,212,0.12) 0%, transparent 70%),
      radial-gradient(ellipse 40% 40% at 10% 80%, rgba(74,154,245,0.08) 0%, transparent 70%);
  }
  .hero-dots {
    position: absolute; inset: 0; pointer-events: none;
    background-image: radial-gradient(circle, rgba(26,111,212,0.15) 1.5px, transparent 1.5px);
    background-size: 36px 36px;
    mask-image: radial-gradient(ellipse 70% 70% at 70% 30%, black 0%, transparent 80%);
  }
  .hero-inner {
    max-width: 1200px; margin: 0 auto; padding: 0 32px;
    display: grid; grid-template-columns: 1fr 1fr; gap: 60px;
    align-items: center; position: relative;
  }
  .hero-tag {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(26,111,212,0.1); color: var(--blue);
    padding: 6px 16px; border-radius: 50px;
    font-size: 13px; font-weight: 600; margin-bottom: 24px;
    border: 1px solid rgba(26,111,212,0.2);
  }
  .hero-tag-dot { width: 6px; height: 6px; background: var(--blue); border-radius: 50%; animation: pulse 2s infinite; }
  @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(1.4)} }
  .hero-title {
    font-family: 'Roboto', sans-serif;
    font-size: clamp(38px, 5vw, 64px);
    font-weight: 800;
    line-height: 1.08;
    color: var(--text-dark);
    margin-bottom: 20px;
    letter-spacing: -1.5px;
  }
  .hero-title span { color: var(--blue); position: relative; }
  .hero-title span::after {
    content: '';
    position: absolute; bottom: 2px; left: 0; right: 0;
    height: 4px; background: linear-gradient(90deg, var(--blue), var(--blue-light));
    border-radius: 4px; opacity: 0.35;
  }
  .hero-desc {
    font-size: 17px; line-height: 1.7; color: var(--text-mid);
    margin-bottom: 36px; max-width: 480px;
  }
  .hero-cta-row {
    display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
  }
  .btn-primary-main {
    display: inline-flex; align-items: center; gap: 10px;
    background: var(--blue); color: white;
    padding: 16px 30px; border-radius: 50px;
    font-weight: 600; font-size: 15px; text-decoration: none;
    transition: all 0.25s; box-shadow: 0 8px 30px rgba(26,111,212,0.35);
  }
  .btn-primary-main:hover { background: var(--blue-dark); transform: translateY(-2px); box-shadow: 0 12px 40px rgba(26,111,212,0.45); }
  .btn-secondary-main {
    display: inline-flex; align-items: center; gap: 8px;
    color: var(--blue); font-weight: 600; font-size: 15px;
    text-decoration: none; padding: 16px 4px;
    transition: gap 0.2s;
  }
  .btn-secondary-main:hover { gap: 12px; }
  .hero-stats {
    display: flex; gap: 32px; margin-top: 48px;
    padding-top: 32px; border-top: 1px solid rgba(26,111,212,0.12);
  }
  .stat-item {}
  .stat-num {
    font-family: 'Roboto', sans-serif;
    font-size: 28px; font-weight: 800; color: var(--blue);
  }
  .stat-label { font-size: 13px; color: var(--text-light); margin-top: 2px; }

  /* Hero phone mockup */
  .hero-visual {
    display: flex; align-items: center; justify-content: center;
    position: relative;
  }
  .phone-stack {
    position: relative; width: 280px; height: 520px;
  }
  .phone-card {
    position: absolute;
    background: white;
    border-radius: 28px;
    box-shadow: 0 30px 80px rgba(26,111,212,0.2), 0 0 0 1px rgba(26,111,212,0.08);
    overflow: hidden;
    transition: transform 0.3s;
  }
  .phone-card.front {
    width: 220px; height: 440px;
    top: 40px; left: 30px;
    z-index: 2;
    animation: float 4s ease-in-out infinite;
  }
  .phone-card.back {
    width: 200px; height: 410px;
    top: 20px; left: 60px;
    z-index: 1; opacity: 0.6;
    animation: float 4s ease-in-out infinite 0.5s;
  }
  @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
  .phone-screen {
    width: 100%; height: 100%;
    background: linear-gradient(160deg, var(--blue) 0%, var(--blue-dark) 100%);
    display: flex; flex-direction: column; align-items: center;
    padding: 32px 20px 24px;
    color: white;
  }
  .phone-notch {
    width: 60px; height: 8px; background: rgba(255,255,255,0.2);
    border-radius: 4px; margin-bottom: 24px;
  }
  .phone-logo-big {
    width: 64px; height: 64px; background: rgba(255,255,255,0.15);
    border-radius: 18px; display: flex; align-items: center; justify-content: center;
    font-family: 'Roboto', sans-serif; font-size: 30px; font-weight: 800;
    margin-bottom: 16px;
  }
  .phone-app-name { font-family: 'Roboto', sans-serif; font-weight: 700; font-size: 15px; margin-bottom: 6px; }
  .phone-app-sub { font-size: 11px; opacity: 0.7; margin-bottom: 24px; text-align: center; }
  .phone-country-list { width: 100%; display: flex; flex-direction: column; gap: 8px; }
  .phone-country-item {
    background: rgba(255,255,255,0.12); border-radius: 10px;
    padding: 10px 12px; display: flex; align-items: center; gap: 10px;
    font-size: 12px; font-weight: 500;
  }
  .phone-country-flag { font-size: 16px; }
  .phone-country-count {
    margin-left: auto; background: rgba(255,255,255,0.2);
    padding: 2px 8px; border-radius: 20px; font-size: 10px;
  }
  .hero-badge {
    position: absolute; right: 0; top: 80px;
    background: white; border-radius: 16px;
    padding: 14px 18px;
    box-shadow: 0 10px 40px rgba(26,111,212,0.15);
    font-size: 12px; font-weight: 600; color: var(--text-dark);
    z-index: 3; animation: float 3s ease-in-out infinite 1s;
    border: 1px solid rgba(26,111,212,0.1);
  }
  .hero-badge-num { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: var(--blue); display: block; }

  /* ── COUNTRIES ── */
  .countries {
    padding: 80px 0;
    background: white;
  }
  .section-inner { max-width: 1200px; margin: 0 auto; padding: 0 32px; }
  .section-label {
    font-size: 12px; font-weight: 700; letter-spacing: 2px;
    color: var(--blue); text-transform: uppercase; margin-bottom: 12px;
  }
  .section-title {
    font-family: 'Syne', sans-serif; font-size: clamp(26px,3.5vw,40px);
    font-weight: 800; color: var(--text-dark); letter-spacing: -0.5px;
    margin-bottom: 16px;
  }
  .section-sub { font-size: 16px; color: var(--text-mid); line-height: 1.7; max-width: 520px; }
  .section-header { margin-bottom: 52px; }

  .countries-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;
  }
  .country-card {
    background: var(--off-white); border-radius: var(--radius);
    padding: 32px 28px;
    border: 1px solid rgba(26,111,212,0.06);
    transition: all 0.3s;
    cursor: default; position: relative; overflow: hidden;
  }
  .country-card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, var(--blue), var(--blue-light));
    transform: scaleX(0); transform-origin: left;
    transition: transform 0.3s;
  }
  .country-card:hover { transform: translateY(-6px); box-shadow: 0 20px 50px rgba(26,111,212,0.12); background: white; }
  .country-card:hover::before { transform: scaleX(1); }
  .country-flag { font-size: 36px; margin-bottom: 16px; display: block; }
  .country-name {
    font-family: 'Roboto', sans-serif; font-size: 18px; font-weight: 700;
    color: var(--text-dark); margin-bottom: 8px;
  }
  .country-desc { font-size: 14px; color: var(--text-light); line-height: 1.6; }
  .country-arrow {
    display: inline-flex; align-items: center; gap: 4px;
    margin-top: 16px; font-size: 13px; font-weight: 600; color: var(--blue);
  }

  /* ── FEATURES ── */
  .features {
    padding: 100px 0;
    background: linear-gradient(160deg, var(--blue-dark) 0%, var(--blue) 60%, var(--blue-mid) 100%);
    position: relative; overflow: hidden;
  }
  .features::before {
    content: ''; position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(255,255,255,0.06) 1px, transparent 1px);
    background-size: 28px 28px;
  }
  .features .section-label { color: rgba(255,255,255,0.6); }
  .features .section-title { color: white; }
  .features .section-sub { color: rgba(255,255,255,0.7); }
  .features-grid {
    display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;
    margin-top: 52px;
  }
  .feat-card {
    background: rgba(255,255,255,0.09);
    border: 1px solid rgba(255,255,255,0.14);
    border-radius: var(--radius); padding: 32px;
    transition: all 0.3s; backdrop-filter: blur(10px);
  }
  .feat-card:hover { background: rgba(255,255,255,0.15); transform: translateY(-4px); }
  .feat-icon {
    width: 52px; height: 52px; background: rgba(255,255,255,0.15);
    border-radius: 14px; display: flex; align-items: center; justify-content: center;
    font-size: 22px; margin-bottom: 20px;
  }
  .feat-title {
    font-family: 'Roboto', sans-serif; font-size: 18px; font-weight: 700;
    color: white; margin-bottom: 10px;
  }
  .feat-desc { font-size: 14px; color: rgba(255,255,255,0.7); line-height: 1.65; }

  /* ── HOW IT WORKS ── */
  .how {
    padding: 100px 0; background: white;
  }
  .steps {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px;
    margin-top: 60px; position: relative;
  }
  .steps::before {
    content: ''; position: absolute;
    top: 38px; left: calc(16.666% + 20px); right: calc(16.666% + 20px);
    height: 2px;
    background: repeating-linear-gradient(90deg, var(--blue) 0, var(--blue) 8px, transparent 8px, transparent 20px);
  }
  .step { text-align: center; }
  .step-num {
    width: 76px; height: 76px; margin: 0 auto 24px;
    background: var(--blue-pale); border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-family: 'Syne', sans-serif; font-size: 26px; font-weight: 800; color: var(--blue);
    border: 3px solid white;
    box-shadow: 0 0 0 6px var(--blue-pale);
    position: relative; z-index: 1;
    transition: all 0.3s;
  }
  .step:hover .step-num { background: var(--blue); color: white; box-shadow: 0 0 0 6px rgba(26,111,212,0.15), 0 12px 30px rgba(26,111,212,0.3); }
  .step-title { font-family: 'Syne', sans-serif; font-size: 17px; font-weight: 700; color: var(--text-dark); margin-bottom: 10px; }
  .step-desc { font-size: 14px; color: var(--text-light); line-height: 1.65; }

  /* ── CTA ── */
  .cta-section {
    padding: 80px 0; background: var(--off-white);
  }
  .cta-card {
    background: linear-gradient(135deg, var(--blue) 0%, var(--blue-dark) 100%);
    border-radius: 28px; padding: 64px 60px;
    text-align: center; position: relative; overflow: hidden;
  }
  .cta-card::before {
    content: ''; position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(255,255,255,0.07) 1px, transparent 1px);
    background-size: 24px 24px;
  }
  .cta-card h2 {
    font-family: 'Syne', sans-serif; font-size: clamp(26px,4vw,44px);
    font-weight: 800; color: white; margin-bottom: 16px; letter-spacing: -0.5px;
    position: relative;
  }
  .cta-card p { font-size: 16px; color: rgba(255,255,255,0.75); margin-bottom: 36px; max-width: 460px; margin-left: auto; margin-right: auto; position: relative; }
  .store-buttons {
    display: flex; justify-content: center; gap: 16px; flex-wrap: wrap;
    position: relative;
  }
  .store-btn {
    display: flex; align-items: center; gap: 12px;
    background: white; color: var(--text-dark);
    padding: 14px 26px; border-radius: 14px;
    text-decoration: none; font-weight: 600; font-size: 14px;
    transition: all 0.25s;
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  }
  .store-btn:hover { transform: translateY(-3px); box-shadow: 0 14px 35px rgba(0,0,0,0.2); }
  .store-btn-icon { font-size: 24px; }
  .store-btn-text { display: flex; flex-direction: column; text-align: left; }
  .store-btn-small { font-size: 10px; font-weight: 400; color: var(--text-light); }
  .store-btn-big { font-size: 15px; font-weight: 700; color: var(--text-dark); }

  /* ── FOOTER ── */
  .footer {
    background: var(--text-dark); padding: 60px 0 32px;
    color: rgba(255,255,255,0.6);
  }
  .footer-inner {
    max-width: 1200px; margin: 0 auto; padding: 0 32px;
  }
  .footer-top {
    display: grid; grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 48px; margin-bottom: 48px;
  }
  .footer-brand-name {
    font-family: 'Syne', sans-serif; font-size: 20px;
    font-weight: 800; color: white; margin-bottom: 12px;
    display: flex; align-items: center; gap: 10px;
  }
  .footer-brand-desc { font-size: 14px; line-height: 1.7; }
  .footer-col-title { font-family: 'Syne', sans-serif; font-size: 14px; font-weight: 700; color: white; margin-bottom: 20px; }
  .footer-links { list-style: none; display: flex; flex-direction: column; gap: 10px; }
  .footer-links a { color: rgba(255,255,255,0.55); text-decoration: none; font-size: 14px; transition: color 0.2s; }
  .footer-links a:hover { color: var(--blue-light); }
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.08); padding-top: 28px;
    display: flex; align-items: center; justify-content: space-between;
    font-size: 13px;
  }
  .footer-bottom a { color: var(--blue-light); text-decoration: none; }

  /* ── RESPONSIVE ── */
  @media(max-width: 900px) {
    .hero-inner { grid-template-columns: 1fr; gap: 40px; }
    .hero-visual { display: none; }
    .countries-grid { grid-template-columns: repeat(2, 1fr); }
    .features-grid { grid-template-columns: 1fr; }
    .steps { grid-template-columns: 1fr; }
    .steps::before { display: none; }
    .footer-top { grid-template-columns: 1fr 1fr; }
    .nav-links { display: none; }
    .cta-card { padding: 40px 28px; }
  }
  @media(max-width: 600px) {
    .countries-grid { grid-template-columns: 1fr; }
    .footer-top { grid-template-columns: 1fr; }
    .hero-stats { flex-wrap: wrap; gap: 20px; }
  }

  /* Fade-in animation */
  .fade-up {
    opacity: 0; transform: translateY(28px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  .fade-up.visible { opacity: 1; transform: translateY(0); }
`;

const countries = [
  { flag: '🇸🇦', name: 'Saudi Arabia', desc: 'Explore hundreds of medical & nursing job offers across KSA hospitals and clinics.' },
  { flag: '🇦🇪', name: 'United Arab Emirates', desc: 'Find premium healthcare opportunities in Dubai, Abu Dhabi, and more.' },
  { flag: '🇶🇦', name: 'Qatar', desc: 'Discover nursing and medical positions in one of the fastest-growing healthcare sectors.' },
  { flag: '🇰🇼', name: 'Kuwait', desc: 'Browse curated offers for registered nurses and medical assistants in Kuwait.' },
  { flag: '🇴🇲', name: 'Oman', desc: 'Access exclusive travel nursing and medical job listings across Oman.' },
  { flag: '🇧🇭', name: 'Bahrain', desc: 'Stay updated on the latest healthcare openings in the Kingdom of Bahrain.' },
];

const features = [
  { icon: '🔍', title: 'Daily Updated Offers', desc: 'Browse fresh travel nursing and medical job offers updated every single day across the Arab Middle East.' },
  { icon: '📋', title: 'Prometric Exam Prep', desc: 'Prepare for RN and medical assistant prometric exams with our comprehensive question banks.' },
  { icon: '✅', title: 'Self-Assessment Tests', desc: 'Test your knowledge with scored exams and track your progress over time.' },
  { icon: '📄', title: 'Document Library', desc: 'Download and review all required prometric and job application documents in one place.' },
];

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);

    // Intersection observer for fade-up
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

    return () => { window.removeEventListener('scroll', onScroll); observer.disconnect(); };
  }, []);

  return (
    <>
      <style>{styles}</style>

      {/* NAV */}
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-inner">
          <a href="#home" className="nav-brand">
            <div className="nav-logo-box">
              <img src="/logo.png" alt="Logo" style={{ width: 80 , height: 80 }} /> 

            </div>
            <span className="nav-brand-name">Nursing Jobs</span>
          </a>
          <ul className="nav-links">
            <li><a href="#home" className="active">Home</a></li>
            <li><a href="#countries">Countries</a></li>
            <li><a href="#features">Features</a></li>
            <li><a href="/privacy-policy">Privacy</a></li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.nursingoffers" className="btn-nav">
                Download App
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero" id="home">
        <div className="hero-bg" />
        <div className="hero-dots" />
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-tag">
              <span className="hero-tag-dot" />
              #1 Medical Jobs App — Arab Middle East
            </div>
            <h1 className="hero-title">
              Your Career in<br />
              <span>Healthcare</span><br />
              Starts Here
            </h1>
            <p className="hero-desc">
              Find the latest travel nursing and medical job offers across Saudi Arabia, UAE, Qatar, Kuwait, Oman, and Bahrain — updated daily, just for you.
            </p>
            <div className="hero-cta-row">
              <a href="https://play.google.com/store/apps/details?id=com.nursingoffers" className="btn-primary-main">
                ⬇ Download Free
              </a>
              <a href="#features" className="btn-secondary-main">
                Explore Features →
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-num">6+</div>
                <div className="stat-label">Countries covered</div>
              </div>
              <div className="stat-item">
                <div className="stat-num">100%</div>
                <div className="stat-label">Free to use</div>
              </div>
              <div className="stat-item">
                <div className="stat-num">Daily</div>
                <div className="stat-label">New offers</div>
              </div>
            </div>
          </div>

          {/* Phone mockup */}
          <div className="hero-visual">
            <div className="phone-stack">
              <div className="phone-card back">
                <div className="phone-screen" style={{ opacity: 0.5 }} />
              </div>
              <div className="phone-card front">
                <div className="phone-screen">
                  <div className="phone-notch" />
                  <div className="phone-logo-big">N</div>
                  <div className="phone-app-name">Nursing Jobs</div>
                  <div className="phone-app-sub">Medical Jobs · Arab World</div>
                  <div className="phone-country-list">
                    {[['🇸🇦','Saudi Arabia','48'],['🇦🇪','UAE','32'],['🇶🇦','Qatar','19'],['🇰🇼','Kuwait','15']].map(([f,n,c]) => (
                      <div className="phone-country-item" key={n}>
                        <span className="phone-country-flag">{f}</span>
                        <span>{n}</span>
                        <span className="phone-country-count">{c} jobs</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="hero-badge">
                <span className="hero-badge-num">6</span>
                Countries
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COUNTRIES */}
      <section className="countries" id="countries">
        <div className="section-inner">
          <div className="section-header fade-up">
            <div className="section-label">Coverage</div>
            <h2 className="section-title">Search Offers by Country</h2>
            <p className="section-sub">We cover all the major healthcare markets in the Arab Middle East, giving you unmatched reach.</p>
          </div>
          <div className="countries-grid">
            {countries.map((c, i) => (
              <div className="country-card fade-up" key={c.name} style={{ transitionDelay: `${i * 80}ms` }}>
                <span className="country-flag">{c.flag}</span>
                <div className="country-name">{c.name}</div>
                <div className="country-desc">{c.desc}</div>
                <div className="country-arrow">Browse offers →</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="features">
        <div className="section-inner">
          <div className="section-label fade-up">What We Offer</div>
          <h2 className="section-title fade-up">Everything You Need,<br />In One App</h2>
          <p className="section-sub fade-up">From job browsing to exam preparation — Nursing Offers is your complete career companion.</p>
          <div className="features-grid">
            {features.map((f, i) => (
              <div className="feat-card fade-up" key={f.title} style={{ transitionDelay: `${i * 100}ms` }}>
                <div className="feat-icon">{f.icon}</div>
                <div className="feat-title">{f.title}</div>
                <div className="feat-desc">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how">
        <div className="section-inner">
          <div className="section-header fade-up" style={{ textAlign: 'center' }}>
            <div className="section-label">How It Works</div>
            <h2 className="section-title">Get Started in Minutes</h2>
          </div>
          <div className="steps">
            {[
              { n: '1', title: 'Download the App', desc: 'Available free on Google Play. Install in seconds on any Android device.' },
              { n: '2', title: 'Pick Your Country', desc: 'Choose from 6 Arab countries and browse all available medical job offers.' },
              { n: '3', title: 'Apply & Grow', desc: 'Find the perfect offer, prepare with our exam tools, and launch your career.' },
            ].map((s, i) => (
              <div className="step fade-up" key={s.n} style={{ transitionDelay: `${i * 130}ms` }}>
                <div className="step-num">{s.n}</div>
                <div className="step-title">{s.title}</div>
                <div className="step-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="section-inner">
          <div className="cta-card fade-up">
            <h2>Ready to Find Your<br />Dream Medical Job?</h2>
            <p>Join thousands of nurses and medical professionals using Nursing Offers to advance their careers across the Arab world.</p>
            <div className="store-buttons">
              <a href="https://play.google.com/store/apps/details?id=com.nursingoffers" className="store-btn">
                <span className="store-btn-icon">▶</span>
                <span className="store-btn-text">
                  <span className="store-btn-small">Get it on</span>
                  <span className="store-btn-big">Google Play</span>
                </span>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.nursingoffers" className="store-btn">
                <span className="store-btn-icon">🍎</span>
                <span className="store-btn-text">
                  <span className="store-btn-small">Download on the</span>
                  <span className="store-btn-big">App Store</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-top">
            <div>
              <div className="footer-brand-name">
                <div className="nav-logo-box">N</div>
                Nursing Offers
              </div>
              <p className="footer-brand-desc">
                Helping nurses and medical professionals find the best travel job opportunities across the Arab Middle East — every day.
              </p>
            </div>
            <div>
              <div className="footer-col-title">Navigate</div>
              <ul className="footer-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#countries">Countries</a></li>
                <li><a href="#features">Features</a></li>
              </ul>
            </div>
            <div>
              <div className="footer-col-title">Countries</div>
              <ul className="footer-links">
                <li><a href="#">Saudi Arabia</a></li>
                <li><a href="#">UAE</a></li>
                <li><a href="#">Qatar</a></li>
                <li><a href="#">Kuwait</a></li>
                <li><a href="#">Oman</a></li>
                <li><a href="#">Bahrain</a></li>
              </ul>
            </div>
            <div>
              <div className="footer-col-title">Legal</div>
              <ul className="footer-links">
                <li><a href="/privacy-policy">Privacy Policy</a></li>
                <li><a href="https://www.facebook.com/arabnurseshub" target="_blank" rel="noreferrer">Contact Us</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2025 Nursing Offers. All rights reserved.</span>
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </>
  );
}